import { render, staticRenderFns } from "./GiphyPicker.vue?vue&type=template&id=b2c9cf4a"
import script from "./GiphyPicker.vue?vue&type=script&lang=js"
export * from "./GiphyPicker.vue?vue&type=script&lang=js"
import style0 from "./GiphyPicker.vue?vue&type=style&index=0&id=b2c9cf4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports